Format = require 'app/scripts/lib/markdown/format'
KnownServices = require 'app/scripts/db/known-services'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
tryBabble = require 'app/scripts/lib/try-babble'
xtend = require 'xtend'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
parseURL = require 'url-parse'

module.exports = do ->
  getAttachmentData: (attachment) ->
    attachmentName = attachment.get('name')
    attachmentUrl = attachment.get('url')
    serviceKey = attachment.getServiceKey()

    KnownServices.interpret(attachmentUrl, attachment.modelCache)
    .then (known) =>
      if known?
        name = attachmentName || known.text
        if name == attachmentUrl
          name = known.text
        return {
          isKnownService: true
          meta: known.name
          previewClass: known.previewClass
          name: name
          type: known.type
        }

      switch serviceKey
        when 'trello'
          meta: Format.bytes(attachment.get 'bytes')
          openText: l('attachments.trello.open')
          openIconClass: 'external-link'
          isExternal: false
        when 'gdrive'
          meta: tryBabble(['mime', attachment.get('mimeType')])
          previewClass: 'attachment-thumbnail-preview-google-drive-logo'
        when 'dropbox'
          previewClass: 'attachment-thumbnail-preview-dropbox-logo'
        when 'onedrive'
          previewClass: 'attachment-thumbnail-preview-one-drive-logo'
        when 'box'
          previewClass: 'attachment-thumbnail-preview-box-logo'
        when 'other'
          ext: 'LINK'
    .then (thumbnailData) ->
      data = xtend {
        isKnownService: false
        isExternal: true
        openIconClass: 'external-link'
      }, attachment.toJSON(), thumbnailData

      # Only try to evaluate these if they haven't already been set
      data.meta ?= l(['attachments', serviceKey, 'type'])
      data.openText ?= l(['attachments', serviceKey, 'open'])
      data.removeText ?= l(['attachments', serviceKey, 'remove'])

      if !data.name
        data.name = data.url

      if !data.ext?
        data.ext = Util.fileExt(attachmentUrl)
        # we probably guessed wrong in this case
        if data.ext? && data.ext.length > 6
          data.ext = null

      data

  availableExts: ->
    if !@_availableExts?
      exts = []
      for mimetype in navigator.mimeTypes
        exts = exts.concat mimetype.suffixes.split(',')

      @_availableExts = _.compact _.uniq exts

    @_availableExts

  imageExts: ->
    [
      'bmp'
      'gif'
      'jpeg'
      'jpg'
      'png'
      'svg'
      'webp'
    ]

  getPlayableExts: (codecs, mediaType) ->
    # You can pass a mime type to canPlayType on a audio or video element to
    # detect if it can be played. http://stackoverflow.com/questions/7451635

    testEl = document.createElement mediaType

    _.chain(codecs)
      .filter(({ types }) -> _.any(types, (t) -> "" != testEl.canPlayType(t)))
      .pluck('exts')
      .flatten()
      .value()

  audioExts: ->

    return @_audioExts if @_audioExts

    codecs = [
      { exts: ['m4a'], types: ['audio/x-m4a;', 'audio/aac;'] }
      { exts: ['mp3'], types: ['audio/mpeg;'] }
      { exts: ['opus'], types: ['audio/ogg; codecs="opus"'] }
      { exts: ['ogg'], types: ['audio/ogg; codecs="vorbis"'] }
      { exts: ['wav'], types: ['audio/wav; codecs="1"'] }
    ]

    @_audioExts = @getPlayableExts(codecs, 'audio')

  videoExts: ->

    return @_videoExts if @_videoExts

    codecs = [
      { exts: ['mp4'], types: ['video/mp4; codecs="mp4v.20.8"'] }
      { exts: ['mov', 'h264'], types: ['video/mp4; codecs="avc1.42E01E"', 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'] }
      { exts: ['ogv'], types: ['video/ogg; codecs="theora"'] }
      { exts: ['webm'], types: ['video/webm; codecs="vp8, vorbis"'] }
    ]

    @_videoExts = @getPlayableExts(codecs, 'video')

  googleViewerableExts: ->
    # https://support.google.com/drive/answer/2423485?p=docs_viewer&rd=1
    defaultExts = [
      'doc'
      'docx'
      'ppt'
      'pptx'
      'rtf'
      'xls'
      'xlsx'
    ]

    # if you can't natively view pdfs, show them in google viewer.
    if !('pdf' in @availableExts())
      defaultExts.push 'pdf'

    @_googleViewerableExts ?= defaultExts

  iFrameableExts: ->
    defaultExts = [
      'css'
      'js'
      'txt'
    ]

    # NOTE: We know that using <iframe src="foo.pdf"></iframe> will possibly allow
    # the PDF to run some limited script.  The script runs on a different origin, so
    # it's not really a terrible risk.  There is the possibility that the PDF will
    # display an alert, which is maybe annoying.  (Because we load the whole carosel
    # the script may get run even if the user is previewing another attachment)
    #
    # We attempted to address this by always using Google's viewer, but that resulted
    # in a lot of PDFs being unviewable for unknown reasons (possibly because they
    # were too large, or too complicated) and caused more of a support problem than
    # the theoretical security issue it was trying to fix.
    #
    # We may be able to resolve this someday by using the atlassian media viewer
    tryExts = [
      'pdf'
    ]

    @_iFrameableExts ?= _.intersection(tryExts, @availableExts()).concat defaultExts

  allViewerableExts: ->
    if @_viewerableExts?
      return @_viewerableExts

    @_viewerableExts = @imageExts()
    .concat @audioExts()
    .concat @videoExts()
    .concat @googleViewerableExts()
    .concat @iFrameableExts()

    @_viewerableExts

  isViewerable: (ext) -> ext in @allViewerableExts()

  stripAndShortenName: (name) ->
    nameShortened = false
    newName = name.replace(/\s+/g, ' ').trim()
    if newName.length > 256
      newName = newName.substring(0, 256)
      nameShortened = true
    return { newName, nameShortened }

  validateUrlAndName: (url, name, originalUrl, originalName, type) ->
    canUpdate = false
    newName = originalName

    # case of no protocol in url from edit attachment input
    parsed = parseURL(url, {})
    if !parsed.protocol
      url = parsed.set('protocol', 'http:').href

    if (type == 'other')
      if (parsed.hostname && url.length > 0)
        if (name.length == 0)
          newName = url
        else
          if (originalUrl == originalName && originalName == name)
            newName = url
          else
            newName = name
        canUpdate = true
    else
      if (name.length > 0)
        newName = name
        canUpdate = true

    return { newName, canUpdate, newUrl: url }
